var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pa-0"},_vm._l((_vm.categories),function(item){return _c('li',{key:item.id},[_c('router-link',{staticClass:"cursor-pointer category_link",class:{
        'category_link--active': _vm.$route.params.category === item.url,
      },attrs:{"to":{
        name: 'Blog categories',
        params: { category: item.url },
      }}},[_vm._v(_vm._s(item.title))]),(item.childrens.length)?_c('nested-categories',{staticClass:"pl-4",attrs:{"categories":item.childrens}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }